"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var NewAdult = function NewAdult() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "8",
    height: "20",
    viewBox: "0 0 8 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M2.11534 19.75V12.9615H0.230713V7.01922C0.230713 6.52212 0.407721 6.09656 0.761738\n5.74255C1.11574 5.38855 1.5413 5.21155 2.03841 5.21155H5.96146C6.45858 5.21155 6.88414 5.38855\n7.23814 5.74255C7.59216 6.09656 7.76916 6.52212 7.76916 7.01922V12.9615H5.88454V19.75L2.11534\n19.75ZM3.99994 3.90385C3.49225 3.90385 3.05764 3.72307 2.69609 3.36152C2.33456 2.99999 2.15379\n2.56538 2.15379 2.0577C2.15379 1.55 2.33456 1.11538 2.69609 0.753848C3.05764 0.392315 3.49225\n0.211548 3.99994 0.211548C4.50762 0.211548 4.94224 0.392315 5.30379 0.753848C5.66532 1.11538\n5.84609 1.55 5.84609 2.0577C5.84609 2.56538 5.66532 2.99999 5.30379 3.36152C4.94224 3.72307 4.50762\n3.90385 3.99994 3.90385Z",
    fill: "#6E6D71"
  }));
};
var _default = NewAdult;
exports.default = _default;